import { apiPost } from '../client';
import { LONG_TIMEOUT_MS } from '../../config/env';
import type { HotelSearchPassengersInfo } from '../types/hotel';
import type {
  CoperReservationListRequest,
  CoperReservationListResponse,
  CoperReservationLoadRequest,
  CoperReservationLoadResponse,
  ReExportCoperJobRequest,
  ReExportCoperJobResponse,
} from '../types/coper';

/**
 * Coper (B2B otel rezervasyon yönetimi) — routes from
 * Docs/api/03-hotel-car-transfer-bus-insurance.md (Hotel section). Legacy MVC had no
 * dedicated CoperController (OtelController existed), so this surface is live-unverified —
 * request/response shapes are code-traced from the backend DTOs / validators. Consumed by
 * the `src/modules/hotel/coper/` sub-area (Master GSA only).
 *
 * (2026-09-08: the Coper cari-hesap routes — `Hotel/SearchCurrency`, `Hotel/NewCurrent`,
 * `Hotel/GetCreditLimit`, `Coper/CoperAcentaList` — were removed together with the
 * "Cari Hesap Yönetimi" screen; see `_excluded.ts`.)
 */

/** `Hotel/ReservationList` — firma (`companyNumber`, zorunlu) + tarih aralığına göre Coper
 *  rezervasyon listesi. */
export function getCoperReservationList(
  req: CoperReservationListRequest
): Promise<CoperReservationListResponse> {
  return apiPost<CoperReservationListRequest, CoperReservationListResponse>('Hotel/ReservationList', req, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}

/** `Hotel/ReservationLoad` — PNR ile tek Coper rezervasyonunun zengin detayı. `PNR_No` key
 *  casing is verbatim (see `CoperReservationLoadRequest` comment). */
export function loadCoperReservation(
  pnrNo: string,
  opts?: {
    language?: string;
    currencyType?: string;
    getFromShoppingCart?: boolean;
    shoppingCartId?: string;
    passengerInfo?: HotelSearchPassengersInfo[];
  }
): Promise<CoperReservationLoadResponse> {
  return apiPost<CoperReservationLoadRequest, CoperReservationLoadResponse>('Hotel/ReservationLoad', {
    PNR_No: pnrNo,
    language: opts?.language,
    currencyType: opts?.currencyType,
    getFromShoppingCart: opts?.getFromShoppingCart,
    shoppingCartId: opts?.shoppingCartId,
    passengerInfo: opts?.passengerInfo,
  });
}

/** `Hotel/ReExportCoper` — bir Hangfire export job'unu yeniden çalıştır. */
export function reExportCoper(jobId: string): Promise<ReExportCoperJobResponse> {
  return apiPost<ReExportCoperJobRequest, ReExportCoperJobResponse>('Hotel/ReExportCoper', { jobId });
}
